async function getCart() {
  const res = await fetch('/cart.js');
  return await res.json();
}

function getUnitValue(item) {
  if (item.properties?._units) {
    return Number(item.properties._units);
  }
  return 1;
}

async function initPromoProgress() {
  const promoBox = document.querySelector('[data-promo-progress]');
  if (!promoBox) return;

  const threshold = Number(promoBox.dataset.threshold);
  if(!threshold || !threshold > 0) {
    return;
  }
  const cart = await getCart();

  let totalUnits = 0;

  cart.items.forEach(item => {
    totalUnits += getUnitValue(item) * item.quantity;
  });

  promoBox.querySelector('.umbral').textContent = threshold;

  const progress = Math.min(totalUnits / threshold, 1) * 100;
  promoBox.querySelector('.promo-progress-bar').style.width = `${progress}%`;

  const remaining = threshold - totalUnits;
  const text = promoBox.querySelector('.promo-remaining');

  text.textContent =
    remaining > 0
      ? `Te faltan ${remaining} para obtener envío gratis`
      : `🎉 ¡Ya tienes envío gratis!`;
}

document.addEventListener('DOMContentLoaded', initPromoProgress);
document.addEventListener('cart:updated', initPromoProgress);
